import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSignaturePad } from '../../ng-signaturepad/models/ng-signaturepad.interfaces';

export type SignatureModalOptions = { topText?: string; bottomText?: string; approval?: boolean; fileLink?: string };

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  standalone: false,
})
export class SignatureComponent implements AfterViewInit {
  @ViewChild('signaturePad', { static: false }) signaturePad: NgSignaturePad;
  public width: number = 400;
  public height: number = 200;
  private type: 'image/jpeg' | 'image/svg+xml';
  public signatureDataURL: string;
  public title: string;
  public options: SignatureModalOptions = {};
  public approved: boolean = false;
  public submitted: boolean = false;

  private confirmCallback: (data?: string) => void;

  constructor(
    private modal: NgbActiveModal,
    private readonly changeDetector: ChangeDetectorRef,
  ) {}

  public ngAfterViewInit(): void {
    if (this.signatureDataURL) {
      this.signaturePad?.fromDataURL(this.signatureDataURL);
      this.changeDetector.detectChanges();
    }
  }

  public get isEmpty(): boolean {
    return this.signaturePad ? this.signaturePad.isEmpty() : true;
  }

  public async confirm(type?: 'image/jpeg' | 'image/svg+xml'): Promise<string> {
    this.type = type;
    return new Promise<string>((resolve: (value: string) => void) => {
      this.confirmCallback = (data?: string) => {
        this.modal.close();
        resolve(data);
      };
    });
  }

  public accept(): void {
    this.submitted = true;
    if (!this.signaturePad.isEmpty() && (!this.options?.approval || this.approved)) {
      this.confirmCallback(this.signaturePad.toDataURL(this.type));
    }
  }

  public cancel(): void {
    this.confirmCallback();
  }

  public clear: () => void = () => this.signaturePad.clear();

  public setOptions(options: SignatureModalOptions) {
    Object.assign(this.options, options);
  }
}
